<template>
  <span :class="['eyecare', { 'no-anim': !hidden, 'anim-completed': animCompleted }]">
    <el-tooltip
      v-if="hidden"
      effect="light"
      popper-class="eyecare_tooltip"
      content="护眼模式已开启"
      placement="bottom-end"
    >
      <div ref="iconRef" class="eyecare_icon" />
    </el-tooltip>
    <span v-if="hidden" ref="tipRef" class="eyecare_tip">护眼模式已开启</span>
  </span>

</template>

<script>
import { Tooltip } from 'element-ui';

export default {
  name: 'Eyecare',
  components: {
    ElTooltip: Tooltip,
  },
  props: {
    hidden: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      animCompleted: false,
    };
  },
  mounted() {
    this.setupAnimationListeners();
  },
  watch: {
    hidden(newVal) {
      if (newVal && !this.animCompleted) {
        this.$nextTick(() => {
          this.setupAnimationListeners();
        });
      }
    },
  },
  methods: {
    setupAnimationListeners() {
      if (!this.hidden || this.animCompleted) return;
      
      this.$nextTick(() => {
        const iconElement = this.$refs.iconRef;
        const tipElement = this.$refs.tipRef;
        
        if (!iconElement) return;
        
        let iconAnimEnded = false;
        let tipAnimEnded = false;
        
        const checkAllAnimationsEnded = () => {
          if (iconAnimEnded && (tipAnimEnded || !tipElement)) {
            this.animCompleted = true;
          }
        };
        
        const handleIconAnimationEnd = (e) => {
          // 只处理退出动画 'out' 的结束事件
          if (e.animationName === 'out') {
            iconAnimEnded = true;
            iconElement.removeEventListener('animationend', handleIconAnimationEnd);
            checkAllAnimationsEnded();
          }
        };
        
        const handleTipAnimationEnd = (e) => {
          // 只处理退出动画 'tipout' 的结束事件
          if (e.animationName === 'tipout') {
            tipAnimEnded = true;
            if (tipElement) {
              tipElement.removeEventListener('animationend', handleTipAnimationEnd);
            }
            checkAllAnimationsEnded();
          }
        };
        
        iconElement.addEventListener('animationend', handleIconAnimationEnd);
        if (tipElement) {
          tipElement.addEventListener('animationend', handleTipAnimationEnd);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/mixin.less";
  .eyecare {
    position: fixed;
    top: 59px;
    right: 16px;
    outline: none;
    pointer-events:none;
    display: flex;
    @keyframes in {
      from {
        opacity: 0;
        transform: translate3d(150px,0,0)
      }
      to {
        opacity: 1;
        transform: translate3d(0,0,0)
      }
    }
    animation: in 0.6s cubic-bezier(0.25,0.1,0.25,1) 0s both;
    // 动画完成后禁用动画并保持最终状态
    &.anim-completed {
      animation: none !important;
      transform: translate3d(0,0,0) !important;
    }
    .hidden {
      visibility: hidden;
      opacity: 0;
      pointer-events: none;
      animation: none !important;
      transition: none !important;
    }

    &_container {
      line-height: 20px;
      height: 20px;
      vertical-align: bottom;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    &_icon {
      pointer-events: all;
      display: inline-block;
      width: 30px;
      height: 20px;
      .bg-img('~@/assets/images/eyescare');
      background-size:contain;
      .eyes_green &{
        .bg-img('~@/assets/images/eyescare_green')
      }
      .eyes_white &{
        .bg-img('~@/assets/images/eyescare_white')
      }
      @keyframes out {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(120px);
        }
      }
      animation: out 0.6s linear 3.6s both;
      // 动画完成后禁用动画并保持最终状态
      .anim-completed & {
        animation: none !important;
        transform: translateX(120px) !important;
      }
    }
    &_tip {
      line-height: 20px;
      display: block;
      flex: 0 0 112px;
      overflow: hidden;
      font-size: 16px;
      text-overflow: clip;
      white-space: nowrap;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      margin-left: 8px;
      @keyframes tipout {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(130px);
          opacity: 0;
        }
      }
      animation: tipout 0.6s linear 3.6s both;
      // 动画完成后禁用动画并保持最终状态（隐藏）
      .anim-completed & {
        animation: none !important;
        transform: translateX(130px) !important;
        opacity: 0 !important;
        visibility: hidden;
      }
      .eyes_white &{
        color: white;
      }
    }
    /* 当 hidden 变化时，禁用所有动画，并确保图标位置保持在 translate3d(0,0,0) */
    &.no-anim {
      animation: none !important;
      transform: translate3d(0,0,0) !important;
      .eyecare_icon {
        animation: none !important;
        transform: translateX(120px) !important;
        @keyframes out {
        from {
          transform: translateX(120px);
        }
        to {
          transform: translateX(120px);
        }
      }
      }
      .eyecare_tip {
        animation: none !important;
        transform: translateX(130px) !important;
        @keyframes tipout {
        from {
          transform: translateX(130px);
          opacity: 0;
        }
        to {
          transform: translateX(130px);
          opacity: 0;
        }
      }
      }
    }
  }
</style>

<style lang="less">
.eyecare_tooltip {
  border: none!important;
  .popper__arrow {
    border: none!important;
  }
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
 }
</style>
